var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, IconButton, Tooltip, Box, Typography, ThemeProvider } from '@mui/material';
import theme from '../theme';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import PushPinIcon from '@mui/icons-material/PushPin';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import FullscreenOutlinedIcon from '@mui/icons-material/FullscreenOutlined';
import FullscreenExitOutlinedIcon from '@mui/icons-material/FullscreenExitOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
export var ButtonIconType;
(function (ButtonIconType) {
    ButtonIconType["edit"] = "edit";
    ButtonIconType["delete"] = "delete";
    ButtonIconType["pin"] = "pin";
    ButtonIconType["pined"] = "pined";
    ButtonIconType["report"] = "report";
    ButtonIconType["create"] = "create";
    ButtonIconType["download"] = "download";
    ButtonIconType["view"] = "view";
    ButtonIconType["more"] = "more";
    ButtonIconType["moreVert"] = "moreVert";
    ButtonIconType["attach"] = "attach";
    ButtonIconType["reset"] = "reset";
    ButtonIconType["fullScreen"] = "fullScreen";
    ButtonIconType["smallScreen"] = "smallScreen";
    ButtonIconType["bell"] = "bell";
    ButtonIconType["overwrite"] = "overwrite";
    ButtonIconType["archive"] = "archive";
})(ButtonIconType || (ButtonIconType = {}));
export var getIconByType = function (type, props) {
    switch (type) {
        case ButtonIconType.edit:
            return _jsx(EditOutlinedIcon, __assign({}, props));
        case ButtonIconType.delete:
            return _jsx(DeleteOutlineOutlinedIcon, __assign({}, props));
        case ButtonIconType.create:
            return _jsx(AddOutlinedIcon, __assign({}, props));
        case ButtonIconType.download:
            return _jsx(FileDownloadOutlinedIcon, __assign({}, props));
        case ButtonIconType.pin:
            return _jsx(PushPinOutlinedIcon, __assign({}, props));
        case ButtonIconType.pined:
            return _jsx(PushPinIcon, __assign({}, props));
        case ButtonIconType.view:
            return _jsx(VisibilityOutlinedIcon, __assign({}, props));
        case ButtonIconType.more:
            return _jsx(MoreHorizIcon, __assign({}, props));
        case ButtonIconType.moreVert:
            return _jsx(MoreVertIcon, __assign({}, props));
        case ButtonIconType.attach:
            return _jsx(AttachFileOutlinedIcon, __assign({}, props));
        case ButtonIconType.reset:
            return _jsx(ReplayOutlinedIcon, __assign({}, props));
        case ButtonIconType.fullScreen:
            return _jsx(FullscreenOutlinedIcon, __assign({}, props));
        case ButtonIconType.smallScreen:
            return _jsx(FullscreenExitOutlinedIcon, __assign({}, props));
        case ButtonIconType.bell:
            return _jsx(NotificationsActiveOutlinedIcon, __assign({}, props));
        case ButtonIconType.overwrite:
            return _jsx(PostAddOutlinedIcon, __assign({}, props));
        case ButtonIconType.archive:
            return _jsx(ArchiveOutlinedIcon, __assign({}, props));
        case ButtonIconType.report:
        default:
            return _jsx(AssignmentOutlinedIcon, __assign({}, props));
    }
};
var ButtonWithIcon = function (_a) {
    var icon = _a.icon, label = _a.label, text = _a.text, color = _a.color, onClick = _a.onClick;
    var buttonColor = icon === ButtonIconType.delete ? 'error' : 'primary';
    buttonColor = color || buttonColor;
    var MuiIcon = getIconByType(icon);
    var button;
    if (text) {
        button = _jsx(Button, __assign({ color: buttonColor, onClick: onClick, startIcon: getIconByType(icon), "data-test_id": "button_".concat(icon) }, { children: _jsx(Typography, { children: text }) }));
    }
    else {
        button = _jsx(Box, { children: _jsx(IconButton, __assign({ onClick: onClick, "data-test_id": "button_".concat(icon) }, { children: getIconByType(icon, { color: buttonColor }) })) });
    }
    return _jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsx(Tooltip, __assign({ arrow: true, placement: 'top', title: label || text || _jsx(Box, __assign({ sx: { textTransform: 'capitalize' } }, { children: icon })) }, { children: button })) }));
};
export default ButtonWithIcon;
